import Modals from '../../Constants/modals';
import ModalManager from './ModalManager';
import CreateVonEmployeeModal from "../Customer/Modals/CreateVonEmployeeModal";

const VonEmployeesModalManager = ({}) => {
    const modalsComponents = {
        [Modals.NewVonEmployeeModal]: CreateVonEmployeeModal
    };

    return <ModalManager modals={modalsComponents} />;
};

export default VonEmployeesModalManager;
